import React from "react";
import Tools from "./Tools";
import { Card, Image } from "antd";
import aura from "../assets/img/aura.png";
import cashbox from "../assets/img/cashbox.png";
import advancly from "../assets/img/advancly.png";

const StacksAndProjects = () => {
  return (
    <div>
      <section id="stacks">
        <p className="fw-bold">Tools</p>
        <div className="container py-5">
          <div className="row">
            <div className="col-lg-12">
              <Tools />
            </div>
          </div>
        </div>
      </section>
      <section id="projects">
        <p className="fw-bold">Launched projects</p>
        <br />
        <div id="advancly">
          <Image src={advancly} width="100%" className="mb-5" />
          <div className="row">
            <div className="col-md-6">
              <div>
                <p className="fw-bold">
                  Advancly
                  <span className="text-muted">
                    {" "}
                    (Frontend/Mobile Team lead)
                  </span>{" "}
                </p>
                <p className="text-primary">
                  {" "}
                  <span className="fw-bold"> Freelance at</span> Advancly
                </p>
                <p>
                  Tech Stack : React, React Native, Redux, Boostrap, Ant Design,
                  SCSS
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <a href="https://www.advancly.com/" target="_blank">
                <Card className="bg-dark text-white">
                  <small>
                    Invest safely and profitably. Build wealth by Powering
                    Progress for businesses in Africa and emerging market.
                  </small>
                  <br />
                  <small className="cursor">https://www.advancly.com/</small>
                </Card>
              </a>
            </div>
          </div>
        </div>

        <br />
        <br />
        <div id="aura">
          <Image src={aura} width="100%" className="mb-5" />
          <div className="row">
            <div className="col-md-6">
              <div>
                <p className="fw-bold">
                  Aura by Transcorp Hotels{" "}
                  <span className="text-muted">(Frontend Team lead)</span>{" "}
                </p>
                <p className="text-primary">
                  {" "}
                  <span className="fw-bold"> Contract at </span> Africa
                  Prudential Plc
                </p>
                <p>Tech Stack : React, Redux, Boostrap, ChartJs, SCSS</p>
              </div>
            </div>

            <div className="col-md-6">
              <a href="https://aura.transcorphotels.com/" target="_blank">
                <Card className="bg-dark text-white">
                  <small>
                    Aura by Transcorp Hotels is a digital platform that connects
                    people to unique accommodation, great food and memorable
                    experiences in Africa influenced by local culture.
                  </small>
                  <br />
                  <small className="cursor">
                    https://aura.transcorphotels.com/
                  </small>
                </Card>
              </a>
            </div>
          </div>
        </div>

        <br />
        <br />
        <div id="cashbox">
          <Image src={cashbox} width="100%" className="mb-5" />
          <div className="row">
            <div className="col-md-6">
              <div>
                <p className="fw-bold">
                  CashBox
                  <span className="text-muted">
                    {" "}
                    (Frontend/Mobile Developer)
                  </span>{" "}
                </p>
                <p className="text-primary">
                  {" "}
                  <span className="fw-bold"> Fulltime at </span> Cashbox Global
                  Services Limited
                </p>
                <p>
                  Tech Stack : React, React Native, Redux, Boostrap, AntDesign,
                  CSS
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <a href="https://cashboxng.com/" target="_blank">
                <Card className="bg-dark text-white">
                  <small>
                    CashBox is a secure savings platform that helps you save
                    money seamlessly all from the comfort of your mobile phone,
                    tablet or computer.
                  </small>
                  <br />
                  <small className="cursor">https://cashboxng.com/</small>
                </Card>
              </a>
            </div>

            <div></div>
          </div>
        </div>

        <br />
        <br />
        <p className="fw-bold">Next Project?</p>
        <p>
          Send me a mail{" "}
          <span className="text-primary">akindiileteforex@gmail.com</span> let’s
          find out
        </p>
      </section>
    </div>
  );
};

export default StacksAndProjects;
